import request from "../util/request";
import axios from "axios";

export const activityClaimantList = (data) => {
  return request({
    url: "/customer/activity-claimant/list",
    method: "post",
    data,
  });
};

export const submitActivityClaimant = (data) => {
  return request({
    url: "/customer/activity-claimant/submit",
    method: "post",
    data,
  });
};

export const cancelActivityClaimant = (data) => {
  return request({
    url: "/customer/activity-claimant/cancel",
    method: "post",
    data,
  });
};

export const revokeActivityClaimant = (data) => {
  return request({
    url: "/customer/activity-claimant/revoke",
    method: "post",
    data,
  });
};

export const updateActivityClaimStatus = (data) => {
  return request({
    url: "/customer/activity-claimant/update/status",
    method: "post",
    data,
  });
};

export const exportActivityClaim = (data) => {
  return request({
    url: "/customer/activity-claimant/export",
    method: "post",
    data,
    responseType: "blob",
  });
};

export const getActivityClaimDetail = (data) => {
  return request({
    url: "/customer/activity-claimant/detail",
    method: "post",
    data,
  });
};

export const saveActivityClaim = (data) => {
  return request({
    url: "/customer/activity-claimant/save",
    method: "post",
    data,
  });
};

export const checkClaimedVinsApi = (data) => {
  return request({
    url: "/customer/activity-claimant/checkClaimedVins",
    method: "post",
    data,
  });
};

export const getActivitySupportList = (data) => {
  return request({
    url: "/customer/activity-claimant/support/list",
    method: "post",
    data,
  });
};

// export const importVinBatch = (data) => {
//   return request({
//     url: "/activity-claimant/import-vin",
//     method: "post",
//     data,
//   });
// };

// export const uploadVinFile = (data) => {
//   return request({
//     url: "/activity-claimant/vin-file/upload",
//     method: "post",
//     data,
//   });
// };
